import { render, staticRenderFns } from "./BadgeManagement.vue?vue&type=template&id=1b012180"
import script from "./BadgeManagement.vue?vue&type=script&lang=js"
export * from "./BadgeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports